import * as React from 'react';
import { createSvgIcon } from '@mui/material';
/**
 * blank - is a custom SVG Icon that displays when an icon is hidden in the Actions Column of the Grid.
 */

var Blank = createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("defs", {
  id: "defs2"
}), /*#__PURE__*/React.createElement("g", {
  id: "layer1"
}, /*#__PURE__*/React.createElement("rect", {
  y: "0",
  x: "0",
  height: "4.2333331",
  width: "4.2333331",
  id: "rect10",
  style: {
    fill: 'none',
    strokeWidth: '0.0560033'
  }
}))), 'Blank');
export { Blank };